var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpProductLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 17,
    viewBox: "0 0 40 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 17,
    rx: 4,
    fill: "#A50033"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84 12.64C5.85 12.64 4.82 11.51 4.82 9V5.05H6.6V9.19C6.6 10.6 7.02 11.1 7.84 11.1C8.65 11.1 9.1 10.6 9.1 9.19V5.05H10.82V9C10.82 11.51 9.82 12.64 7.84 12.64ZM12.087 12.5V5.05H14.707C16.337 5.05 17.687 5.64 17.687 7.48C17.687 9.25 16.327 10.03 14.747 10.03H13.877V12.5H12.087ZM13.877 8.62H14.657C15.527 8.62 15.947 8.21 15.947 7.48C15.947 6.73 15.467 6.47 14.607 6.47H13.877V8.62ZM23.8522 4.05H25.4722V13.43H23.8522V4.05ZM25.0622 7.52H26.6722V8.84H25.0622V7.52ZM21.3522 5H22.9322C22.9322 7.9 21.9422 10.31 18.7722 11.91L17.8722 10.69C20.2622 9.44 21.3522 7.86 21.3522 5.29V5ZM18.4322 5H22.1822V6.29H18.4322V5ZM31.9014 6.4H33.9814V7.69H31.9014V6.4ZM33.1514 4.07H34.7714V10.89H33.1514V4.07ZM28.4614 12.03H34.9614V13.31H28.4614V12.03ZM28.4614 10.33H30.0814V12.82H28.4614V10.33ZM28.8914 5.33H30.2014V5.83C30.2014 7.63 29.4814 9.34 27.5514 9.95L26.7514 8.67C28.3814 8.15 28.8914 6.94 28.8914 5.83V5.33ZM29.2414 5.33H30.5314V5.83C30.5314 6.87 31.0214 8.02 32.5714 8.53L31.7914 9.78C29.9214 9.19 29.2414 7.56 29.2414 5.83V5.33ZM27.1714 4.63H32.2314V5.9H27.1714V4.63Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpProductLabel);
export default __webpack_public_path__ + "static/media/up_product_label.e42f16cfd6c772ebf62a3023a4ac1891.svg";
export { ForwardRef as ReactComponent };